import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { getNeonColor } from "../theme";
import { useTheme } from "@mui/system";

interface NeonIconBoxProps {
    children: React.ReactNode;
    color?: string;
    size?: number;
    sx?: SxProps<Theme>;
}

export function NeonIconBox({ children, color, size = 56, sx }: NeonIconBoxProps) {
    const theme = useTheme();
    const resolvedColor = color ?? getNeonColor(theme);

    return (
        <Box
            sx={{
                width: size,
                height: size,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 2,
                bgcolor: `${resolvedColor}15`,
                border: `1px solid ${resolvedColor}40`,
                boxShadow: `0 0 20px ${resolvedColor}20`,
                transition: "all 0.2s ease",
                "& svg": {
                    fontSize: size * 0.57,
                    color: resolvedColor,
                    filter: `drop-shadow(0 0 6px ${resolvedColor})`,
                },
                "&:hover": {
                    boxShadow: `0 0 28px ${resolvedColor}35`,
                    borderColor: `${resolvedColor}60`,
                },
                ...sx,
            }}
        >
            {children}
        </Box>
    );
}
